import { BaseTrackingReport } from '@/features/projects/kpi-tracking-entry/api/get-tracking-reports';
import { supabase } from '@/lib/supabase';

export const deleteTrackingReport = async (
  trackingReportId: number,
): Promise<BaseTrackingReport> => {
  const { data, error } = await supabase
    .from('kpi_tracking_reports')
    .delete()
    .eq('id', trackingReportId)
    .select()
    .single();

  if (error) throw error;

  return data;
};
